import React, { useState } from 'react';
import useFetch from '../../../../hooks/useFetch'; // Make sure this path is correct
import axios from 'axios';
import Cookies from 'js-cookie';

const Change2FA = () => {
  const [isUpdating, setIsUpdating] = useState(false);
  const [statusMessage, setStatusMessage] = useState(null);
  const [error, setError] = useState(null);

  // Use your hook to fetch current user info
  const { data: userData, isLoading, errorMessage, fetchData } = useFetch(
    `${process.env.REACT_APP_API_URL}/profile/`,
    true
  );

  const toggle2FA = async () => {
    if (!userData) return;

    setIsUpdating(true);
    setError(null);
    setStatusMessage(null);

    const token = Cookies.get('access_token');

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/enable-2fa/`,
        { enable_2fa: !userData.enable_2fa },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      setStatusMessage(response.data.message || '2FA status updated.');
      fetchData(); // Refresh user data from API
    } catch (err) {
      console.error('2FA update error:', err);
      setError('Failed to update 2FA setting.');
    } finally {
      setIsUpdating(false);
    }
  };

  if (isLoading) return <p>Loading user info...</p>;
  if (errorMessage) return <p className="text-danger">{errorMessage}</p>;

  const is2FAEnabled = userData?.enable_2fa;

  return (
    <div className="card">
      <div className="card-body">
        <h5 className="mb-2">Two-Factor Authentication (2FA)</h5>
        <p>Status: <strong>{is2FAEnabled ? 'Enabled' : 'Disabled'}</strong></p>

        {statusMessage && <div className="alert alert-success">{statusMessage}</div>}
        {error && <div className="alert alert-danger">{error}</div>}

        <button
          className={`btn ${is2FAEnabled ? 'btn-danger' : 'btn-success'}`}
          onClick={toggle2FA}
          disabled={isUpdating}
        >
          {isUpdating ? 'Updating...' : is2FAEnabled ? 'Disable 2FA' : 'Enable 2FA'}
        </button>
      </div>
    </div>
  );
};

export default Change2FA;
